import { iTab2Props } from '../../types/iTabs';
import { EpisodesList } from '../EpisodesList';
import { Separator } from '@intigral/shared';

export const Tab2: React.FC<iTab2Props> = ({ setRuntimeLength, seasons, seasonOrderDescending }) => {
    return (
        <>
            <Separator color="dark" marginTop={{ default: '2x' }} />
            <EpisodesList
                setRuntimeLength={setRuntimeLength}
                seasons={seasons}
                seasonOrderDescending={seasonOrderDescending}
            />
        </>
    );
};
